var map = {
	"./1.png": 9240,
	"./10.png": 9082,
	"./11.png": 307,
	"./12.png": 5032,
	"./13.png": 9249,
	"./14.png": 8238,
	"./16.png": 140,
	"./17.png": 5589,
	"./19.png": 4299,
	"./2.png": 6099,
	"./3.png": 8346,
	"./4.png": 2117,
	"./5.png": 9852,
	"./6.png": 8855,
	"./7.png": 3985,
	"./8.png": 5881,
	"./9.png": 7760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;